import React from "react";
import CreateCentralCredentialsCard from "./CentralCredentialsCard";
import { CardTypes } from "./CentralCredentialsCardService";

function CentralCredentialsCardModal({ handleClose, cardType, centralCredentialsId }) {
    const isCreateMode = cardType === CardTypes.CREATE;

    return (
        <div className="modal oct_display-block modal-v2-root oct_auth-v2-modal oct_auth-v2-modal--credentials">
            <div className="modal fade oct_modal show modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog oct_auth-v2-modal-dialog" aria-modal="true">
                    <div className="modal-content modal-v2-shell oct_auth-v2-modal-shell">
                        <div className="modal-v2-header oct_auth-v2-modal-header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading">
                                        {isCreateMode ? "Create Central Credentials" : "Edit Central Credentials"}
                                    </h2>
                                    <p className="modal-v2-subheading">
                                        {isCreateMode
                                            ? "Store a reusable credential set for authentication and device workflows."
                                            : "Update the selected credential profile without changing the surrounding auth layout."}
                                    </p>
                                </div>
                                <button type="button" className="close modal-v2-close" aria-label="Close" onClick={handleClose}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>

                        <CreateCentralCredentialsCard handleClose={handleClose} cardType={cardType} centralCredentialsId={centralCredentialsId} />
                    </div>
                </div>
            </div>
        </div>
    )

}


export default CentralCredentialsCardModal;
